import type { ReactNode } from 'react';
import { Button } from './Button';

interface StickyCTAProps {
  visible?: boolean;
  onClick: () => void;
  children: ReactNode;
}

export function StickyCTA({
  visible = false,
  onClick,
  children,
}: StickyCTAProps) {
  return (
    <div
      data-testid="sticky-cta"
      className={`
        fixed bottom-0 left-0 right-0
        z-50
        md:hidden
        bg-white dark:bg-gray-900
        shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]
        p-4 pb-safe
        transition-transform duration-300 ease-out
        ${visible ? 'translate-y-0' : 'translate-y-full'}
      `}
    >
      <Button
        variant="primary"
        size="lg"
        fullWidth
        onClick={onClick}
      >
        {children}
      </Button>
    </div>
  );
}
